var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export default function defaultAdapter(options) {
    var productIdentifier = options.productIdentifier, serial = options.serial, urlPrefix = options.urlPrefix;
    var getDetails = function () {
        return fetch("".concat(urlPrefix, "/customers/").concat(serial, "/licenses/details?productIdentifier=").concat(productIdentifier), {
            method: 'GET'
        })
            .then(function (res) { return res.json(); })
            .then(function (data) { return ({
            sku: data.product_sku,
            serialNo: data.serial,
            paidLicenses: data.paid_license_count,
            unlicensedUsers: data.overage_license_count,
            licensesInUseCount: data.used_license_count,
            licenseRenewalDate: data.license_expiration_date,
            companyName: data.account_name,
            partnerName: data.partner_name,
            leadsTokens: data.available_leads_tokens,
            bccID: data.bccID,
            country: data.country,
            postalCode: data.postal_code,
            state: data.state
        }); });
    };
    var getUsers = function () {
        return fetch("".concat(urlPrefix, "/customers/").concat(serial, "/licenses/users?productIdentifier=").concat(productIdentifier), {
            method: 'GET'
        })
            .then(function (res) { return res.json(); })
            .then(function (data) {
            var users = data.users;
            return users.map(function (user) { return ({
                email: user.email,
                firstName: user.first_name,
                lastName: user.last_name,
                licenses: user.license_types || [],
                products: user.products || []
            }); });
        });
    };
    var requestLicenses = function (formData) {
        return fetch("".concat(urlPrefix, "/customers/").concat(serial, "/licenses/leads"), {
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(__assign(__assign({}, formData), { productIdentifier: productIdentifier }))
        }).then(function (res) {
            if (res.ok) {
                return true;
            }
            throw new Error('Invalid request from license leads.');
        });
    };
    return {
        getDetails: getDetails,
        getUsers: getUsers,
        requestLicenses: requestLicenses
    };
}
//# sourceMappingURL=defaultAdapter.js.map